module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8cfc79915028f43d481bd5ea8eafc9ed.png";